export default {
  namespaced: true,
  providers: {
    title: "Providers"
  }
}
